import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import SvgModalClose from "@/app/components/lib/SvgModalClose";
import { IuseProductHasAttrsResult } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";
import { Col, Modal, Row } from "@/utils/bootstrap";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  productState: IuseProductHasAttrsResult;
  agree: boolean;
}

const DisbledReasonModal: React.FC<Props> = ({
  show,
  setShow,
  productState,
  agree,
}) => {
  const t = useTranslation();
  const {
    shouldConfig,
    variantNotExist,
    requiredAddonsNotChosen,
    outOfStock,
    isDisabled,
  } = productState;
  return (
    <Modal
      centered
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="messagebox-dialog"
      contentClassName="messagebox-cart-disabled"
    >
      <div className="messagebox-closeicon">
        <SvgModalClose onClick={() => setShow(false)} />
      </div>
      {/* <div className="messagebox-title">{t.terms_conditions}</div> */}
      <div className="messagebox-message" style={{ textAlign: "center" }}>
        {!agree
          ? t.you_should_agree_to_terms_conditions
          : shouldConfig
          ? t.choose_variant
          : variantNotExist
          ? t.this_variant_not_available
          : isDisabled
          ? t.product_disabled
          : outOfStock
          ? t.out_of_stock
          : requiredAddonsNotChosen
          ? t.choose_required_addons
          : t.sell_disabled}
      </div>
      <Row className="m-0 w-100">
        <Col className="p-0">
          <div className="w-100">
            <CustomButton
              type={BtnTypes.primary}
              size={BtnSizes.large}
              radius={BtnRadius.small}
              fullWidth
              onClick={() => {
                setShow(false);
              }}
            >
              {t.ok}
            </CustomButton>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default DisbledReasonModal;
